import { useState } from 'react';
import { ProcessingModal } from './ProcessingModal';
import { handleClose } from '../../common';
import { APIEndPoints, Request } from '../../apis';
import { z } from 'zod';
import { useParams } from 'react-router-dom';

type TChangeSubCourseStatus = {
  isModalOpen: boolean;
  handleModalClose: () => void;
  id: string;
  details: {
    id: string;
    name: string;
    status: string;
  };
  setTriggerUpdate: () => void;
};

type TProcessedMsg = string | null;

const ChangeSubCourseStatus = ({
  isModalOpen,
  handleModalClose,
  id,
  details,
  setTriggerUpdate
}: TChangeSubCourseStatus) => {
  const [changingStatus, setChangingStatus] = useState(false);
  const [processedMsg, setProcessedMsg] = useState<TProcessedMsg>(null);
  const [statusChangeSuccessful, setStatusChangeSuccessful] = useState(false);
  // const [triggerUpdate, setTriggerUpdate] = useState(false);
  const { merchantId } = useParams();

  const statusPatchSchema = z.object({
    id: z.string(),
    status: z.number(),
    message: z.string()
  });

  const updateStatus = async () => {
    setChangingStatus(true);

    try {
      const statusPatch = await Request.patch(
        `${APIEndPoints.courses}/${merchantId}/${id}/subCategory/${details.id}/status?access_token`,
        statusPatchSchema,
        {
          status: details.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
        }
      );

      setChangingStatus(false);
      setStatusChangeSuccessful(true);
      setProcessedMsg('Status has been updated successfully');
    } catch {
      setChangingStatus(false);
      setProcessedMsg('Something went wrong when updating status');
    }
  };

  const refreshPage = () => {
    if (statusChangeSuccessful) {
      setTriggerUpdate();
    }
    setStatusChangeSuccessful(false);
    handleClose(handleModalClose);
  };

  return (
    <ProcessingModal
      isModalOpen={isModalOpen}
      handleModalClose={() => refreshPage()}
      processing={changingStatus}
      title={`${
        details.status === 'ACTIVE' ? 'Deactivate' : 'Activate'
      } Sub Course "${details.name}"`}
      processedMsg={processedMsg}
      confirmation={true}
      confirmationMessage={`Are you sure you want to ${
        details.status === 'ACTIVE' ? 'deactivate' : 'activate'
      } this sub course`}
      handleConfirmation={() => updateStatus()}
    />
  );
};

export { ChangeSubCourseStatus };
